document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('MainContent');
  if (!main) return;

  var template = main.getAttribute('data-template') || '';
  var isHome = template === 'index';
  var isProduct = template.indexOf('product') === 0;

  if (isHome) {
    // The exhibition is the permanent/default homepage experience.
    document.body.setAttribute('data-jalx-mode', 'exhibition');

    // Every randomized artwork travels with its own product data. That means
    // title, price, dimensions, availability and links always belong to the
    // image currently shown in that scene.
    (function randomizeHomepageArtworks() {
      function shuffled(items) {
        var copy = items.slice();
        for (var i = copy.length - 1; i > 0; i -= 1) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = copy[i];
          copy[i] = copy[j];
          copy[j] = temp;
        }
        return copy;
      }

      function parseDimensions(title) {
        var match = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?/i);
        return match ? { width: match[1], height: match[2] } : null;
      }

      function dimensionsFor(product) {
        var parsed = parseDimensions(product.title);
        return {
          width: product.widthCm || (parsed && parsed.width) || '',
          height: product.heightCm || (parsed && parsed.height) || ''
        };
      }

      function setHref(element, url, suffix) {
        if (!element || !url) return;
        element.setAttribute('href', url + (suffix || ''));
      }

      function setImage(image, product) {
        if (!image || !product) return;
        var widths = [320, 480, 640, 960, 1280, 1600, 2200];
        function imageUrl(width) {
          var url = new URL(product.image, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.href;
        }
        var sizes = image.getAttribute('sizes') || '100vw';
        image.sizes = image.loading === 'lazy' && sizes.indexOf('auto') !== 0
          ? 'auto, ' + sizes
          : sizes;
        image.srcset = widths.map(function (width) {
          return imageUrl(width) + ' ' + width + 'w';
        }).join(', ');
        image.src = imageUrl(960);
        image.alt = product.title || 'J-ARTSWORK artwork';
        image.dataset.randomProductUrl = product.url || '';
        image.dataset.randomProductTitle = product.title || '';
      }

      function syncHero(section, product) {
        var title = section.querySelector('.ja-arrival__meta--right span:first-child');
        if (title) title.textContent = product.title || 'J-ARTSWORK';
      }

      function syncScale(section, product) {
        var dims = dimensionsFor(product);
        var horizontal = section.querySelector('.ja-scale__measure--h span');
        var vertical = section.querySelector('.ja-scale__measure--v span');
        var headingSpans = section.querySelectorAll('.ja-scale__story h2 > span');
        var heading = section.querySelector('.ja-scale__story h2');

        var horizontalWrap = section.querySelector('.ja-scale__measure--h');
        var verticalWrap = section.querySelector('.ja-scale__measure--v');

        if (dims.width && dims.height) {
          if (horizontal) horizontal.textContent = dims.width + ' CM';
          if (vertical) vertical.textContent = dims.height + ' CM';
          if (headingSpans[0]) headingSpans[0].textContent = dims.width;
          if (headingSpans[1]) headingSpans[1].textContent = dims.height;
          if (heading) heading.hidden = false;
          if (horizontalWrap) horizontalWrap.hidden = false;
          if (verticalWrap) verticalWrap.hidden = false;
        } else {
          // Never show fallback dimensions for another artwork.
          if (heading) heading.hidden = true;
          if (horizontalWrap) horizontalWrap.hidden = true;
          if (verticalWrap) verticalWrap.hidden = true;
          if (horizontal) horizontal.textContent = '';
          if (vertical) vertical.textContent = '';
        }

        setHref(section.querySelector('.ja-exp__link'), product.url);
      }

      function syncSpace(section, product) {
        setHref(section.querySelector('.ja-exp__link'), product.url, '?view_room=1');
      }

      function syncCollect(section, product) {
        var title = section.querySelector('.ja-collect__info h2');
        var price = section.querySelector('.ja-collect__price');
        var acquire = section.querySelector('.ja-exp__acquire');
        var facts = section.querySelector('.ja-collect__facts');

        if (title) title.textContent = product.title || '';
        if (price) price.textContent = product.price || '';
        setHref(acquire, product.url);

        if (facts) {
          facts.innerHTML = product.available
            ? '<span>ORIGINAL</span><span>SIGNED</span><span>ONE OF ONE</span>'
            : '<span>ORIGINAL</span><span>ONE OF ONE</span><span>SOLD</span>';
        }

        if (acquire) {
          acquire.innerHTML = product.available
            ? 'Acquire this work <span>↗</span>'
            : 'View this work <span>↗</span>';
        }
      }

      function syncScene(section, product) {
        if (!section || !product) return;
        section.querySelectorAll('[data-ja-home-art-link]').forEach(function (link) {
          setHref(link, product.url);
          link.setAttribute('aria-label', product.title || 'J-ARTSWORK');
        });
        if (section.classList.contains('ja-hero')) syncHero(section, product);
        if (section.classList.contains('ja-scale')) syncScale(section, product);
        if (section.classList.contains('ja-space-portal')) syncSpace(section, product);
        if (section.classList.contains('ja-collect')) syncCollect(section, product);
      }

      // Shuffle standard Horizon product cards as complete cards, preserving
      // all native card data and links.
      document.querySelectorAll('.ui-test-product-list').forEach(function (section) {
        var items = Array.from(section.querySelectorAll('.resource-list__item'));
        if (items.length < 2) return;
        var parent = items[0].parentElement;
        if (!parent) return;
        shuffled(items).forEach(function (item) { parent.appendChild(item); });
      });

      var poolElement = document.getElementById('JArtworkHomepageProductPool');
      if (!poolElement) return;

      var pool = [];
      try {
        pool = JSON.parse(poolElement.textContent || '[]').filter(function (product) {
          return product && product.image && product.url;
        });
      } catch (error) {
        return;
      }
      if (!pool.length) return;

      // One product is selected per exhibition scene. If a scene contains
      // multiple copies of the image (the canvas-break panels), all copies use
      // the same product instead of accidentally mixing artworks.
      var scenes = Array.from(document.querySelectorAll([
        '.ja-hero',
        '.ja-material',
        '.ja-scale',
        '.ja-canvas-break',
        '.ja-space-portal',
        '.ja-collect',
        '.ja-finale'
      ].join(',')));

      var choices = shuffled(pool);
      scenes.forEach(function (section, index) {
        if (index >= choices.length) choices = choices.concat(shuffled(pool));
        var product = choices[index];
        if (!product) return;

        section.dataset.randomProductUrl = product.url || '';
        section.dataset.randomProductTitle = product.title || '';
        section.querySelectorAll('img').forEach(function (image) {
          setImage(image, product);
        });
        syncScene(section, product);
      });
    })();

    var canvasBreak = document.querySelector('.ja-canvas-break');
    if (canvasBreak && 'IntersectionObserver' in window) {
      var canvasObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          canvasBreak.classList.toggle('is-passed', entry.isIntersecting && entry.intersectionRatio > 0.35);
        });
      }, { threshold: [0.35] });
      canvasObserver.observe(canvasBreak);
    }
  }

  document.querySelectorAll('.ja-exp, .ja-statement, .ja-product-experience > *').forEach(function (el) {
    el.setAttribute('data-jalx-reveal', '');
  });

  if ('IntersectionObserver' in window) {
    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          reveal.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('[data-jalx-reveal]').forEach(function (el) { reveal.observe(el); });
  } else {
    document.querySelectorAll('[data-jalx-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  if (isProduct) {
    var privateView = document.querySelector('[data-ja-private-view]');

    function closePrivate() {
      if (!privateView) return;
      privateView.classList.remove('is-open');
      privateView.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('jalx-private-open');
    }

    function openPrivate() {
      if (!privateView) return;
      privateView.classList.add('is-open');
      privateView.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('jalx-private-open');
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ja-private-open]')) {
        event.preventDefault();
        openPrivate();
        return;
      }

      var close = event.target.closest('[data-ja-private-close]');
      if (close) {
        closePrivate();
        return;
      }

      var acquire = event.target.closest('[data-ja-private-acquire]');
      if (acquire) {
        closePrivate();
        var buyButton = document.querySelector('.product-form__submit, form[action*="/cart/add"] button[type="submit"]');
        if (buyButton) buyButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && privateView && privateView.classList.contains('is-open')) {
        closePrivate();
      }
    });
  }
});
